import { generateClient } from 'aws-amplify/api';
import { updateTimeSheet } from "../graphql/mutations";
import createTimesheet from "./createTimesheet";

const client = generateClient();

export default async ({ id, jobId, scope, startDate, endDate, userId, crewMember, timeEntries }) => {
    try {
        let timesheet;
        if (id) {
            const { data } = await client.graphql({
                query: updateTimeSheet,
                variables: {
                    input: {
                        id,
                        jobNumber: jobId,
                        scope,
                        startDate,
                        endDate,
                        userId,
                        crewMember,
                    },
                },
            });
            timesheet = data.updateTimeSheet;
        } else {
            timesheet = await createTimesheet({
                jobNumber: jobId,
                scope,
                startDate,
                endDate,
                userId,
                crewMember,
            });
        }
        return timesheet;
    } catch (ex) {
        console.error("Failed to update timesheet", ex);
    }
};
